// This file is auto-generated by dibs-icons script
import { FC } from 'react';

type InfoCircle20Props = {
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const InfoCircle20: FC<InfoCircle20Props> = props => {
    return (
        <svg
            style={{ display: 'block' }}
            data-tn={props.dataTn}
            role={props.role}
            aria-label={props.ariaLabel}
            aria-labelledby={props.ariaLabelledby}
            width="20"
            height="20"
        >
            <path d="M10.656 9.125V13.5H9.344V9.125h1.312ZM10.465 7.625a.644.644 0 0 1-.469.188.625.625 0 0 1-.465-.192.644.644 0 0 1-.187-.469c0-.184.064-.34.191-.464a.644.644 0 0 1 .469-.188.644.644 0 0 1 .652.66c0 .185-.064.34-.191.465Z" />
            <path
                d="M17 10a7 7 0 1 1-14 0 7 7 0 0 1 14 0Zm-1.5 0a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0Z"
                fillRule="evenodd"
                clipRule="evenodd"
            />
        </svg>
    );
};

export default InfoCircle20;
